import axios from "axios";
import { API_BASE_URL } from "../utils/apiConfig";

export interface ChatMessage {
  role: "user" | "assistant" | "system";
  content: string;
}

export interface ChatResponse {
  message: ChatMessage;
}

export async function sendChatMessage(messages: ChatMessage[]): Promise<ChatResponse> {
  const { data } = await axios.post<ChatResponse>(
    `${API_BASE_URL}/chat/`,
    { messages },
    { withCredentials: true }
  );
  return data;
}
